export default "__VITE_ASSET__wMq33oB4__"